import GridElement from "../GridElement";
import GridWrapper from "../GridWrapper";
import styles from "./Schedule.module.css";
import ScheduleList from "../ScheduleList/ScheduleList";
import { Tournament } from "../../types/tournament";

export interface ScheduleProps {
  firstSeasonTournaments: Array<Tournament>;
  secondSeasonTournaments: Array<Tournament>;
  thirdSeasonTournaments: Array<Tournament>;
}

const Schedule = ({
  firstSeasonTournaments,
  secondSeasonTournaments,
  thirdSeasonTournaments,
}: ScheduleProps) => {
  return (
    <GridWrapper className={styles.scheduleGridWrapper}>
      <GridElement gridLayout={[[1401, 5, 24]]}>
        {(firstSeasonTournaments?.length > 0 ||
          secondSeasonTournaments?.length > 0) && (
          <section>
            <ScheduleList
              firstSeasonTournaments={firstSeasonTournaments}
              secondSeasonTournaments={secondSeasonTournaments}
              thirdSeasonTournaments={thirdSeasonTournaments}
            />
          </section>
        )}
      </GridElement>
    </GridWrapper>
  );
};

export default Schedule;
